import { Tooltip, type TooltipProps } from '@mui/material';
import React from 'react';

export type VyTooltipProps = Omit<TooltipProps, 'title' | 'children'> & {
  tooltipContent?: React.ReactNode;
  children: React.ReactElement;
};

export const VyTooltip: React.FC<VyTooltipProps> = ({ tooltipContent, children, ...props }) => {
  if (!tooltipContent) {
    return children;
  }

  return (
    <Tooltip title={tooltipContent} arrow {...props}>
      {children}
    </Tooltip>
  );
};
